import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import router from '@/helpers/router/router';

Vue.use(VueAnalytics, {
  id: 'UA-133880153-3',
  disableScriptLoader: true,
  router,
  autoTracking: {
    transformQueryString: false,
    exception: true,
    screenview: true,
    skipSamePath: true
  },
  debug: {
    sendHitTask: process.env.NODE_ENV === 'production',
    enabled: process.env.NODE_ENV !== 'production'
  }
});
